import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { getCurrentVisiblePeesBySite } from 'reducers/currentSelection'
import { DataManagementTable } from './DataManagementTable'
import DropdownMenuButton from 'components/common/DropdownMenuButton'
import { Export } from './Export'
import { Import } from './Import'
import { Rollout } from './Rollout'
import { request } from '../sites/request'

const useSites = () => {
  const perimeter = useSelector(getCurrentVisiblePeesBySite)
  const peeNums = perimeter.flatMap(item => item.pees.map(pee => pee.PeeClef));
  const peeIds = perimeter.flatMap(item => item.pees.map(pee => pee.id));
  
    const { data, isFetching, isLoading } = useQuery(['compteurs', { perimeter }], () =>
      perimeter && perimeter.length > 0
        ? request({ url: 'consommations/compteurs/sites', method: 'POST', body: peeIds })
        : () => Promise.resolve([])
    )
  
    return { data, isFetching, isLoading };
}

export const DataManagement = () => {
  const [siteId, setSiteId] = React.useState(null)
  const { t } = useTranslation()
  const { data: meters, isFetching, isLoading } = useSites()
  const [currentView, setCurrentView] = useState('table');
  const [selectedIds, setSelectedIds] = useState([]);

const handleSelectionChange = React.useCallback((ids) => {
    setSelectedIds(ids);
  }, []);

  const myDropdownItems = [
    { label: t('dataManagement.menu.export'), onClick: () => setCurrentView('export') },
    { label: t('dataManagement.menu.import'), onClick: () => setCurrentView('import') },
    { label: t('dataManagement.menu.rollout'), onClick: () => setCurrentView('rollout') },
  ];

  const siteName = siteId === null ? null : meters[siteId].SphNom

  return (
    <>
        <div
          css={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '1rem',
            button: {
            marginLeft: '1rem',
            svg: {
              transform: 'scale(1.4) translateY(-1px)',
              marginRight: '0.8rem',
            },
          },
          }}
        >
          <DropdownMenuButton title={t('dataManagement.menu.title')} items={myDropdownItems} direction="down" right={true} />
          
        </div>
      
      <div className="content-area">
        {currentView === 'table' && <DataManagementTable meters={meters} isFetching={isFetching} onSelectionChange={handleSelectionChange} />}
        
        {currentView === 'export' && <Export onBack={() => setCurrentView('table')} selectedIds={selectedIds}/>}
        
        {currentView === 'import' && <Import onBack={() => setCurrentView('table')} selectedIds={selectedIds}/>}
        
        {currentView === 'rollout' && <Rollout onBack={() => setCurrentView('table')} selectedIds={selectedIds}/>}
      </div>
    
    </>
  )
}
